import { createFileRoute } from "@tanstack/react-router";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";
import { z } from "zod";
import CreditsTable from "@/components/invoices/credits/credits-table";

const creditsSearchSchema = z.object({
  page: z.number().optional().default(1),
  search: z.string().optional(),
  status: z.string().optional(),
  clientId: z.string().optional(),
});

export const Route = createFileRoute(
  "/_authenticated/invoices/credits/",
)({
  validateSearch: creditsSearchSchema,
  component: InvoicesCreditsPage,
});

function InvoicesCreditsPage() {
  const searchParams = Route.useSearch();

  return (
<RouteGuardPermissions
      permissions={[{ module: "client_credits", actions: ["read"] }]}>
      
    <div>
      <CreditsTable
        currentPage={searchParams.page}
        basePath="/invoices/credits"
        searchParams={searchParams}
      />
    </div>
  
    </RouteGuardPermissions>
  );
}
